// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pZoQ","question":"styles_question__2jpsp","description":"styles_description__27kGU"};